export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_EMAIL = "UPDATE_EMAIL";